export default __webpack_public_path__ + "static/media/subtract-fill.ae7b2d8a.svg";